const API_KEY = '1';

const API = {
  BASE_URL: `https://www.themealdb.com/api/json/v1/${API_KEY}`,
  FILTER_ENDPOINT: 'filter.php',
  LOOKUP_ENDPOINT: 'lookup.php',
  SEARCH_ENDPOINT: 'search.php',
};

export default API;
